"use strict";
// Copyright (c) 2021-2024, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
($ => {
    $.loadGoogleCharts = function (options = {}) {
        var _a;
        (_a = options.packages) !== null && _a !== void 0 ? _a : (options.packages = ['corechart']);
        return new Promise(resolve => {
            $.getScript('https://www.gstatic.com/charts/loader.js', () => {
                var _a;
                (_a = options.version) !== null && _a !== void 0 ? _a : (options.version = 'current');
                google.charts.load(options.version, { packages: options.packages });
                google.charts.setOnLoadCallback(() => {
                    return resolve();
                });
            });
        });
    };
    $.loadGoogleFonts = function (families, display = 'swap') {
        if (!Array.isArray(families)) {
            families = [families];
        }
        const header = $('head');
        $('<link>')
            .attr('rel', 'preconnect')
            .attr('href', 'https://fonts.gstatic.com')
            .appendTo(header);
        class FontURL {
            constructor(display = 'swap') {
                this.arguments = [];
                this.addArgument('display', display);
            }
            addFamily(family) {
                const value = encodeURIComponent(family);
                this.addArgument('family', `${value}:ital,wght@0,400;0,700;1,400;1,700`);
            }
            toString() {
                return `https://fonts.googleapis.com/css2?${this.arguments.join('&')}`;
            }
            addArgument(key, value) {
                this.arguments.push(`${key}=${value}`);
            }
        }
        const font_css_url = new FontURL(display);
        families.forEach(family => font_css_url.addFamily(family));
        $('<link>')
            .attr('href', font_css_url.toString())
            .attr('rel', 'stylesheet')
            .appendTo(header);
    };
    {
        let loaded = false;
        $.loadGoogleMaps = function (API_KEY_1) {
            return __awaiter(this, arguments, void 0, function* (API_KEY, element = $(document.body), options = $.USACentered()) {
                if (loaded) {
                    return new google.maps.Map(element.element(), options);
                }
                else {
                    return new Promise((resolve, reject) => {
                        var _a, _b, _c, _d, _e;
                        (_a = options.language) !== null && _a !== void 0 ? _a : (options.language = 'en');
                        (_b = options.libraries) !== null && _b !== void 0 ? _b : (options.libraries = []);
                        (_c = options.version) !== null && _c !== void 0 ? _c : (options.version = 'weekly');
                        (_d = options.center) !== null && _d !== void 0 ? _d : (options.center = $.USACentered().center);
                        (_e = options.zoom) !== null && _e !== void 0 ? _e : (options.zoom = $.USACentered().zoom);
                        const params = new URLSearchParams();
                        params.set('key', API_KEY.trim());
                        params.set('callback', 'WebUIInitializeMap');
                        params.set('v', options.version.toString().trim());
                        params.set('language', options.language.trim());
                        if (options.libraries.length !== 0) {
                            params.set('libraries', options.libraries.map(elem => elem.trim()).join(','));
                        }
                        if (options.region)
                            params.set('region', options.region.trim());
                        window.WebUIInitializeMap = () => {
                            delete window.WebUIInitializeMap;
                            loaded = true;
                            return resolve(new google.maps.Map(element.element(), options));
                        };
                        $.ajax({
                            url: `https://maps.googleapis.com/maps/api/js?${params.toString()}`,
                            dataType: 'script',
                            error: error => {
                                return reject(error);
                            }
                        });
                    });
                }
            });
        };
    }
    $.USACentered = function () {
        return {
            center: {
                lat: 39.8097343,
                lng: -98.5556199
            },
            zoom: 5
        };
    };
})(window.$);
//# sourceMappingURL=google.js.map